import { useContext } from "react"
import { AppContext } from "../App"
import { STR_GET_STARTED, STR_INTRO_2, STR_POWERED_BY } from "../Strings";
import logo_icon from "../assets/logo_icon.png";
import logo_worded_only2 from "../assets/logo_worded_only2.png";

export default function Login(props) {

  const appContext = useContext(AppContext);

  function getStarted() {
    appContext.navTo({
      item: 'view',
      subItem: 'login',
    })
  }

  return (
    <div className="Login bg-background">
      <div className="launch mNoScrollBar">
        <div className="container">
          <div className="row min-vh-100 align-items-center">

            <div className="col-md-6 text-center d-flex flex-column justify-content-center">
              <div className="mb-4">
                <img
                  src={logo_icon}
                  alt="Kamola"
                  style={{ width: "120px" }}
                />
              </div>

              <div>
                <img
                  src={logo_worded_only2}
                  alt="Kamola LandLink"
                  style={{ width: "260px" }}
                />
              </div>
            </div>

            <div className="col-md-6 d-flex justify-content-center">
              <div
                className="card"
                style={{
                  maxWidth: "420px",
                  width: "100%",
                  borderRadius: "18px",
                }}
              >
                <div className="card-body" style={{ padding: "40px 30px" }}>
                  <h5
                    className="font-regular text-center mb-4"
                    style={{ fontSize: "22px", lineHeight: "1.4" }}
                  >
                    {STR_INTRO_2[appContext.language]}
                  </h5>

                  <p className="text-center text-muted mb-5" style={{ fontSize: "14px" }}>
                    {STR_POWERED_BY[appContext.language]}
                  </p>

                  <button
                    className="btn btn-padded btn-block btn-primary btn-rounded mb-3"
                    style={{ textTransform: "capitalize", fontSize: "15px" }}
                    onClick={getStarted}
                  >
                    {STR_GET_STARTED[appContext.language]}
                  </button>

                  <button
                    className="btn btn-padded btn-block bg-background btn-rounded"
                    style={{
                      textTransform: "capitalize",
                      fontSize: "14px",
                      border: "1px solid #e5e5e5",
                    }}
                    onClick={() => appContext.changeLanguage()}
                  >
                    {(appContext.language === 'en') ? "Use Swahili" : "Use English"}
                  </button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}
